import { Budget } from '../../../../@types/budget';
import api from '../../../../services/api/api';
import { CreateBudgetInput } from './interfaces';

export const createBudgetDraft = async (budgetData: CreateBudgetInput) => {
  const res = await api.post<Budget>('/budget/draft', budgetData);
  return res;
};

export const transformBudgetDraft = async (budgetDraftId: string) => {
  const res = await api.post<Budget>(
    `/budget/draft/transform/${budgetDraftId}`,
  );
  return res;
};
